<template>
  <div>
    <top-bar />
    <header>
      <Menu />
    </header>
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import TopBar from '@/components/common/TopBar'
import Menu from '@/components/common/Menu'
import Footer from '@/components/common/Footer'
export default {
  name: 'App',
  components: {
    TopBar,
    Menu,
    Footer
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue